<template>
  <div>
    <b-form class="d-flex" @submit.prevent="">
      <div class="d-flex">
        <label for="area-name">{{ $t('nome-da-area') }}</label>
        <input ref="input" @keydown.enter="saveForm" @keydown.esc="cancelForm" type="text" name="area-name" v-model="node.areaName" id="area-name">
      
      </div>
      <div class="d-flex">
        <label for="area-font">{{ $t('tamanho-da-fonte') }}</label>
        <input @keydown.enter="saveForm" @keydown.esc="cancelForm" type="number" name="area-font" v-model.number="node.fontSize" id="area-font">
      </div>
      <b-button @click="openArea" class="mt-2">{{ $t('salvar-e-abrir-area') }}</b-button>
    </b-form>
  </div>
</template>

<script>
  export default {
    props: {
      node: {
        type: Object,
        default: null
      },
    },
    

    inject: ['saveForm', 'cancelForm'],

    data() {
      return {
        heigth: this.node.heigth,
        width: this.node.width,
      }
    },

    watch:{},

    methods:{

      openArea() {
        this.node.openArea = true
        this.saveForm()
      }


    },
    

    mounted() {
      this.resizeDialog()
    }
  }
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}

.d-flex{
  display: flex;
  flex-direction: column;
}
</style>